import { render, staticRenderFns } from "./ConstructorComponent.vue?vue&type=template&id=d90c1c42"
import script from "./ConstructorComponent.vue?vue&type=script&lang=js"
export * from "./ConstructorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports